import React, { useRef } from 'react';

import MSearchInputView from './MSearchInput.view';

type Props = {
  value?: string;
  placeholder?: string;
  size?: 's' | 'm' | 'l';
  alwaysOpen?: boolean;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearGeneralFilters?: () => void;
};

const MSearchInput: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <MSearchInputView
      inputRef={inputRef}
      alwaysOpen={props.alwaysOpen}
      value={props.value}
      placeholder={props.placeholder}
      disabled={props.disabled}
      onIconClick={() => inputRef.current?.focus()}
      onClearGeneralFilters={props.onClearGeneralFilters}
      onChange={props.onChange}
      className={props.className}
      containerClassName={props.containerClassName}
    >
      {props.children}
    </MSearchInputView>
  );
};

MSearchInput.displayName = 'MSearchInput';
MSearchInput.defaultProps = {};

export default MSearchInput;
